import {
  lightGrey,
  peacockBlue,
  skyBlue,
  waterBlue,
} from '@g4/boneyard/lib/theme/colors';

import {
  white,
  black,
  blue100,
  blue500,
  blue900,
  lightBlue900,
  greyA100,
  grey50,
  grey100,
  grey500,
  yellow100,
  green50,
  grey900,
  red500,
  green100,
} from './colors';
// import {red500} from "@g4/booking/src/theme/theme/colors";

const colors = {
  alertRed: red500,
  light: white,
  dark: black,
  primary: blue900,
  waterBlue: waterBlue,
  secondary: blue100,
  secondaryText: lightBlue900,
  textSecondary: grey900,
  secondaryStroke: blue500,
  alternate: blue500,
  alternateText: lightBlue900,
  disabled: grey100,
  disabledText: grey500,
  shadow: greyA100,
  border: grey50,
  warning: yellow100,
  notification: yellow100,
  selection: green50,
  focus: blue100,
  link: '#1871ca',
  linkActive: '#13589c',
  peacockBlue: peacockBlue,
  formPlaceholder: '#716f6f',
  lightYellow: '#fff1b2',
  taEnrollmentSuccessBackGround: green100,
  taBackground: '#f4f5f6',
  silver: '#c0c0c0',
  form: {
    required: red500,
    focused: skyBlue,
    outline: lightGrey,
    stroke: grey100,
    radio: {
      checked: peacockBlue,
      background: white,
      stroke: lightGrey,
    },
    checkbox: {
      active: peacockBlue,
      background: white,
      stroke: lightGrey,
    },
  },
};

export default colors;
